module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', {
    staticClass: "share-container"
  }, [_c('c-navbar', {
    attrs: {
      "title": "邀请好友，积累基金"
    }
  }), _vm._v(" "), _c('c-content', [_c('div', {
    staticClass: "share-box"
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', [_vm._v("￥")]), _vm._v(" "), _c('span', {
    staticClass: "price-number"
  }, [_vm._v("\n            " + _vm._s(_vm._f("currencyNormal")(_vm.totalAmount)) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center desc"
  }, [_vm._v("当前生意基金 "), _c('br'), _vm._v("（活动期间可直接抵扣）")]), _vm._v(" "), _c('div', {
    staticClass: "split-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "share-desc"
  }, [_c('div', {
    staticClass: "text-center bold share-desc-title"
  }, [_vm._v("生意基金积累规则")]), _vm._v(" "), _c('div', {
    staticClass: "mt-20 bold"
  }, [_vm._v("5.7~5.17预热活动期间：积累")]), _vm._v(" "), _c('div', [_vm._v("\n            5.7~5.17预热活动期间每有一个好友通过您分享注册成功，您可获得"), _c('span', {
    staticClass: "text-brown"
  }, [_vm._v("5元")]), _vm._v("生意基金（最多可积累"), _c('span', {
    staticClass: "text-brown"
  }, [_vm._v("200元")]), _vm._v("）。\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-10 bold"
  }, [_vm._v("\n            5.18~5.22正式活动期间：使用\n          ")]), _vm._v(" "), _c('div', [_vm._v("购买活动商品时，可使用您已积累的生意基金直接抵扣。")])])]), _vm._v(" "), _c('div', {
    staticClass: "share-panel"
  }, [_c('div', {
    staticClass: "share-line"
  }, [_c('span', {
    staticClass: "bg-color white"
  }, [_vm._v("分享链接")])]), _vm._v(" "), _c('div', {
    staticClass: "share-item"
  }, _vm._l((_vm.shareItem), function(item) {
    return _c('div', {
      on: {
        "click": function($event) {
          _vm.shareTo(item.method)
        }
      }
    }, [_c('div', {
      staticClass: "pl-20 pr-20"
    }, [_c('img', {
      staticClass: "share-icon",
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pt-10 share-name text-center"
    }, [_vm._v(_vm._s(item.name))])])])
  }))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-704d5455","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tabs/2018-05-18/share/index.vue
// module id = 1060
// module chunks = 2